import _miradorImageToolsPlugin from './plugins/miradorImageToolsPlugin';
export { _miradorImageToolsPlugin as miradorImageToolsPlugin };